import { ACTION_TYPES } from "../../actions/common/UserProfileActions"
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
const initialState = {
    list: [],
    groups: [],
    suppliers: [],
    branchOffices: [],
    branchOfficeServices: [],
    role: ''
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_USER_PROFILE:
            return {
                ...state,
                list: [action.payload],
                groups: action.payload.data.groups,
                suppliers: action.payload.data.suppliers,
                branchOffices: action.payload.data.branchOffices,
                branchOfficeServices: action.payload.data.branchOfficeServices,
                role: action.payload.data.role
            }
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                list: [],
                groups: [],
                suppliers: [],
                branchOffices: [],
                branchOfficeServices: [],
                role: ''
            }
        default:
            return state
    }
}


const persistConfig = {
    key: 'userProfile',
    storage,
};

const UserProfileReducer = persistReducer(persistConfig, reducer);

export default UserProfileReducer;